(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9065],{

/***/ 19065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content009Entry": function() { return /* binding */ Content009Entry; },
  "default": function() { return /* binding */ Content009_Content009Entry; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.Provider.js
var Tabs_Provider = __webpack_require__(11742);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/components/LazyRenderingButton/index.js + 3 modules
var LazyRenderingButton = __webpack_require__(41141);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.hooks.js
var Tabs_hooks = __webpack_require__(60419);
// EXTERNAL MODULE: ./src/components/widgets/content/Content009/Content009.module.scss
var Content009_module = __webpack_require__(19642);
var Content009_module_default = /*#__PURE__*/__webpack_require__.n(Content009_module);
// EXTERNAL MODULE: ./src/components/widgets/content/Content009/LecturersList/LecturersList.module.scss
var LecturersList_module = __webpack_require__(19527);
var LecturersList_module_default = /*#__PURE__*/__webpack_require__.n(LecturersList_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content009/LecturersList/LecturersList.jsx






var LecturersList = function(param) {
    var people = param.people, activePositionTab = param.activePositionTab, tabsHeaderEnabled = param.tabsHeaderEnabled;
    var ref = (0,LazyRenderingButton/* useLazyRenderingState */.vO)(), limit = ref.limit, resetState = ref.resetState;
    var ref1 = (0,Tabs_hooks/* useTabsState */.n)(), activeTab = ref1.activeTab, tabsEnabled = ref1.tabsEnabled, isDefaultTab = ref1.isDefaultTab;
    var filteredLecturers = (0,react.useMemo)(function() {
        if (!tabsEnabled || isDefaultTab) {
            return people;
        }
        return people.filter(function(param) {
            var tags = param.tags;
            return tags === null || tags === void 0 ? void 0 : tags.includes(activeTab);
        });
    }, [
        tabsEnabled,
        isDefaultTab,
        people,
        activeTab
    ]);
    var filteredLecturersByPosition = (0,react.useMemo)(function() {
        return filteredLecturers.filter(function(param) {
            var position = param.position;
            return (position === null || position === void 0 ? void 0 : position.toLowerCase()) === (activePositionTab === null || activePositionTab === void 0 ? void 0 : activePositionTab.toLowerCase());
        });
    }, [
        activePositionTab,
        filteredLecturers
    ]);
    var slicedLecturers = (0,react.useMemo)(function() {
        if (tabsHeaderEnabled) {
            return filteredLecturersByPosition.slice(0, limit);
        }
        return filteredLecturers.slice(0, limit);
    }, [
        filteredLecturers,
        filteredLecturersByPosition,
        limit,
        tabsHeaderEnabled, 
    ]);
    (0,react.useEffect)(function() {
        resetState();
    }, [
        activeTab,
        resetState
    ]);
    return slicedLecturers.map(function(param) {
        var person = param.person;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (LecturersList_module_default()).item,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                directory: "teachers",
                slug: person.slug,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (LecturersList_module_default())["item-wrap"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LecturersList_module_default()).photo,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                                    image: person.photo,
                                    className: (LecturersList_module_default()).image
                                }),
                                person.teacherType && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (LecturersList_module_default()).type,
                                    children: person.teacherType
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LecturersList_module_default()).teacher,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading6 */.Cd, {
                                    as: "h6",
                                    className: (LecturersList_module_default()).title,
                                    children: person.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                    className: (LecturersList_module_default()).description,
                                    color: "dark",
                                    children: person.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: (LecturersList_module_default()).icon,
                                    name: "arrow_right"
                                })
                            ]
                        })
                    ]
                })
            })
        }, person.id);
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content009/LecturersList/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content009/Content009.jsx











var Content009 = function(param) {
    var payload = param.payload;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref;
    var headerTitle = (ref = payload === null || payload === void 0 ? void 0 : payload.headerTitle) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var listTitle = (ref1 = payload === null || payload === void 0 ? void 0 : payload.listTitle) !== null && ref1 !== void 0 ? ref1 : "";
    var people = (0,react.useMemo)(function() {
        var ref;
        return (ref = payload === null || payload === void 0 ? void 0 : payload.items) !== null && ref !== void 0 ? ref : [];
    }, [
        payload === null || payload === void 0 ? void 0 : payload.items
    ]);
    var ref2;
    var template = (ref2 = payload === null || payload === void 0 ? void 0 : payload.backgroundColor) !== null && ref2 !== void 0 ? ref2 : "light";
    var ref3;
    var tabsHeaderEnabled = (ref3 = payload === null || payload === void 0 ? void 0 : payload.showHeaderTabs) !== null && ref3 !== void 0 ? ref3 : false;
    var ref4 = (0,Tabs_hooks/* useTabsState */.n)(), resetActiveTab = ref4.resetActiveTab, setItems = ref4.setItems, tabsEnabled = ref4.tabsEnabled;
    var extractedButtons = (0,_to_consumable_array/* default */.Z)(new Set(people.map(function(item) {
        return item.position;
    }))).filter(Boolean);
    var ref5 = (0,react.useState)(extractedButtons[0]), activePositionTab = ref5[0], setActivePositionTab = ref5[1];
    var extractedTabs = (0,react.useMemo)(function() {
        if (tabsHeaderEnabled) {
            return (0,_to_consumable_array/* default */.Z)(new Set(people.filter(function(param) {
                var position = param.position;
                return position === activePositionTab;
            }).map(function(item) {
                return item.tags;
            }).filter(Boolean).flat()));
        }
        return (0,_to_consumable_array/* default */.Z)(new Set(people.map(function(item) {
            return item.tag;
        }).filter(Boolean).flat()));
    }, [
        activePositionTab,
        people,
        tabsHeaderEnabled
    ]);
    var handleClickOnPositionTab = (0,react.useCallback)(function(tab) {
        return function() {
            setActivePositionTab(tab);
        };
    }, []);
    (0,react.useEffect)(function() {
        setItems(extractedTabs);
        resetActiveTab();
    }, [
        resetActiveTab,
        setItems,
        extractedTabs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Content009_module_default()).wrapper, (Content009_module_default())[template]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            className: (Content009_module_default()).inner,
            children: [
                tabsHeaderEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Content009_module_default()).block,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading1 */.nL, {
                            className: (Content009_module_default()).headline,
                            children: headerTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Content009_module_default()).buttons,
                            children: extractedButtons.map(function(button) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Content009_module_default()).position, (0,_define_property/* default */.Z)({}, (Content009_module_default())["position-active"], button === activePositionTab)),
                                    onClick: handleClickOnPositionTab(button),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                            className: (Content009_module_default()).button,
                                            children: t(button)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            name: "large_arrow_down",
                                            className: (Content009_module_default()).icon
                                        })
                                    ]
                                }, button);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content009_module_default()).top,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Content009_module_default()).header,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((Content009_module_default()).title, (0,_define_property/* default */.Z)({}, (Content009_module_default())["title-margin"], tabsHeaderEnabled || tabsEnabled)),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                                    children: tabsHeaderEnabled ? t("our_".concat(activePositionTab)) : listTitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Tabs */.mQ, {
                                appearance: "justify"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content009_module_default()).content,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyRenderingButton/* LazyRenderingProvider */.Bv, {
                        size: people.length,
                        initialLimit: 6,
                        incrementBy: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Content009_module_default()).items,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LecturersList, {
                                    people: people,
                                    activePositionTab: activePositionTab,
                                    tabsHeaderEnabled: tabsHeaderEnabled
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LazyRenderingButton */.WJ, {
                                appearance: template
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Content009_Content009 = (Content009);

;// CONCATENATED MODULE: ./src/components/widgets/content/Content009/Content009Entry.jsx




var Content009Entry = function(param) {
    var payload = param.payload;
    var ref;
    var tabsEnabled = (ref = payload === null || payload === void 0 ? void 0 : payload.showListTabs) !== null && ref !== void 0 ? ref : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Provider/* TabsProvider */.X, {
        tabsEnabled: tabsEnabled,
        defaultTab: true,
        items: [],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content009_Content009, {
            payload: payload
        })
    });
};
/* harmony default export */ var Content009_Content009Entry = (Content009Entry);


/***/ }),

/***/ 19642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content009_wrapper__ImyRT","light":"Content009_light__Gqwv2","grey":"Content009_grey__ZsN9A","top":"Content009_top__OKN5T","header":"Content009_header__cVYWl","title":"Content009_title__uOISk","items":"Content009_items__L5Sai","block":"Content009_block__9MdHh","headline":"Content009_headline__QrLUY","buttons":"Content009_buttons__PhyaH","button":"Content009_button__Q0Ghd","position":"Content009_position__5EJE_","icon":"Content009_icon__xeGH5","position-active":"Content009_position-active__mi58E","title-margin":"Content009_title-margin__u0kMM"};

/***/ }),

/***/ 19527:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"LecturersList_item__gQj6A","item-wrap":"LecturersList_item-wrap__3r5CC","teacher":"LecturersList_teacher__fCiQ7","photo":"LecturersList_photo__F6GuL","type":"LecturersList_type__vE638","title":"LecturersList_title__wLJyK","description":"LecturersList_description__WvaV_","icon":"LecturersList_icon__bRY_r"};

/***/ })

}]);